import { render, staticRenderFns } from "./other-party.vue?vue&type=template&id=127ffd18&"
import script from "./other-party.vue?vue&type=script&lang=js&"
export * from "./other-party.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports